import React from 'react';
import { PRICE, TOTAL_VALUE, SAVINGS, DISCOUNT } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
type FinalCtaProps = {
  showUrgency?: boolean;
};
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="bg-mint-800 py-20 sm:py-28" aria-labelledby="cierre-title" data-id="element-75" data-mp="15ckkcxgpcgd0">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-76" data-mp="1jc3e2l8rnp5s">
        <Reveal data-id="element-77" data-mp="1ee1wy5uwhzwy">
          <h2 id="cierre-title" className="font-display text-3xl leading-tight text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-78" data-mp="1eek1rqvmpmgh">
            El próximo pedido de 10, 20 o 30 personas puede llegarte esta semana. Que te encuentre con el menú, la lista y la cotización listos.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-mint-100" data-id="element-79" data-mp="223mhuuam778v">
            Recetas con costo por pieza, menús completos y un plan de 30 días. Todo para tu cocina de casa.
          </p>
        </Reveal>

        {showUrgency ? <Reveal delay={0.06} className="mt-12" data-id="element-80" data-mp="n6nt13xlwezf">
            <CountdownTimer tone="dark" label="PRECIO ESPECIAL DE LANZAMIENTO" note={`Ahorras ${SAVINGS} sobre el valor total.`} data-id="element-81" data-mp="n7yxz72sfss4" />
          </Reveal> : null}

        <Reveal delay={0.08} data-id="element-82" data-mp="x2za07855t07">
          <div className="mt-12 rounded-3xl bg-sand px-8 py-10 sm:px-12" data-id="element-83" data-mp="x5v7jug2ufo4">
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-terra-dark" data-id="element-84" data-mp="124g8xx72f5e5">
              Pack completo
            </p>
            <p className="mt-3 text-[15px] text-ink-soft" data-id="element-85" data-mp="1b3jrn02blis4">
              3 tomos + 40 recetas + 6 menús + plan de 30 días + 5 bonos
            </p>
            <p className="mt-5 text-sm text-ink-muted" data-id="element-86" data-mp="1fvl00awdapcv">
              <span className="line-through" data-id="element-87" data-mp="1ktd03s761hs5">{TOTAL_VALUE}</span> · {DISCOUNT} de descuento
            </p>
            <p className="mt-1 font-display text-5xl text-ink" data-id="element-88" data-mp="1pspq2ltc34yy">{PRICE}</p>
            <div className="mt-7" data-id="element-89" data-mp="1pqmor5mqdpex">
              <CtaButton data-id="element-90" data-mp="1ttjd7cyycfqs">Quiero empezar a vender</CtaButton>
            </div>
            <p className="mt-5 text-xs text-ink-muted" data-id="element-91" data-mp="3quowstf7croc">
              El cobro se hace en la moneda de tu país. Pago 100% seguro ·
              Acceso inmediato · Garantía de 7 días.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}